import {Grid, Typography} from '@mui/material';
import './component.css';
import React from 'react';
import {useTranslation} from 'react-i18next';
import AgyleButton from '../../../ui/buttons/agyleButton';
import EditIcon from '@mui/icons-material/Edit';
import {hasPermission, Permissions, sendUserAudit} from '../../../../store/reducers/user';
import {setSnackbar} from '../../../../store/reducers/globals';
import {setDemographicPatient, setReturnToPatientAfterRegistry} from '../../../../store/reducers/patient';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {getConfig} from '../../../../util/configUtil';
import { AUDIT_TYPES } from '../../../../util/auditUtil';
import { ctxPatientPastActivity, ctxPatientType } from '../../../../store/reducers/patientContext';
import { PATIENT_CONTEXT_TYPE } from '../../../../util/patientContextUtil';

const PatientDemographic = ({patient}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const history = useHistory();

    // Selectors
    const patientPastActivity = useSelector(ctxPatientPastActivity);
    const patientType = useSelector(ctxPatientType);

    const canAdmit = dispatch(hasPermission(Permissions.AGYLE_CAN_ADMIT_PATIENT));
    const registrationEnabled = getConfig('admitPatient.registration', false);

    const renderAddress = (address, index) => {
        let text = '';
        text = address.postalCode ? `${address.postalCode}\n` : '-';
        if (address.addressLines && address.addressLines.length > 0) {
            address.addressLines.forEach(element => {
                text += element ? `${element}\n` : '';
            });
        }
        return (
            <Grid key={index} item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {`${t('Home Address')} ${index + 1}`}
                </Typography>

                <Typography variant="body1" className="body">
                    {t('Type')}: {address.typeName || '-'}
                </Typography>

                <Typography variant="body1" className="body" style={{whiteSpace: 'pre-wrap'}}>
                    {text}
                </Typography>
            </Grid>
        );
    };

    const renderPhoneNumbers = (phone, index) => {
        return (
            <Grid key={index} item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {`${t('Telephone')}${phone?.numberType ? ` (${phone.numberType})` : '-'}`}
                </Typography>

                <Typography variant="body1" className="body" style={{whiteSpace: 'pre-wrap'}}>
                    {phone?.number || '-'}
                </Typography>
            </Grid>
        );
    };

    const renderEmails = (email, index) => {
        return (
            <Grid key={index} item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {`${t('Email Address')} ${index + 1}`}
                </Typography>

                <Typography variant="body1" className="body" style={{whiteSpace: 'pre-wrap'}}>
                    {email?.emailAddress || '-'}
                </Typography>
            </Grid>
        );
    };

    const handleChangeDemographic = () => {
        if (canAdmit) {
            if (patient?.patient?.tags?.includes('temporary')) {
                dispatch(setSnackbar({type: 'warning', message: t('Patient is temporary and cannot be edited.')}));
            } else {
                dispatch(sendUserAudit(patient, AUDIT_TYPES.EDIT_PATIENT_DEMOGRAPHIC));
                
                const returnId = patientType === PATIENT_CONTEXT_TYPE.REVIEW ? "REVIEW" :  patient?.__id;

                dispatch(setReturnToPatientAfterRegistry(returnId));
                dispatch(setDemographicPatient(patient));
                history.push('/registry');
            }
        } else {
            dispatch(setSnackbar({type: 'warning', message: t('You do not have permission to edit this patient.')}));
        }
    };

    return (
        <Grid container spacing={1} columns={9} className="container" alignContent="flex-start">
            <Grid item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {t('Name')}
                </Typography>

                <Typography variant="body1" className="body">
                    {patient?.patient?.firstName || '-'}
                </Typography>
            </Grid>

            <Grid item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {t('Surname')}
                </Typography>

                <Typography variant="body1" className="body">
                    {patient?.patient?.familyName || '-'}
                </Typography>
            </Grid>

            <Grid item xs={3} className="container-grid">
                <Typography variant="body1" className="title">
                    {t('Middle Name')}
                </Typography>

                <Typography variant="body1" className="body">
                    {patient?.patient?.middleNames || '-'}
                </Typography>
            </Grid>

            {patient?.patient?.addresses?.map((address, index) => (
                renderAddress(address, index)
            ))}

            {patient?.patient?.phoneNumbers?.map((address, index) => (
                renderPhoneNumbers(address, index)
            ))}

            {patient?.patient?.emails?.map((address, index) => (
                renderEmails(address, index)
            ))}

            {(canAdmit && registrationEnabled) &&
                <Grid item xs={9} style={{position: 'fixed', bottom: 10, right: 320}}>
                    <AgyleButton
                        colour="primary"
                        startIcon={<EditIcon fontSize="small"/>}
                        size="small"
                        onClick={handleChangeDemographic}
                        disabled={patientPastActivity}
                    >
                        {t('Edit')}
                    </AgyleButton>
                </Grid>
            }
        </Grid>
    );
};

export default React.memo(PatientDemographic);